// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "motionplan/v1/motionplan.proto" (package "motionplan.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Offline RDK FK for motion-plan JSON.
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { MotionPlanService } from "./motionplan";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ComputePlanFramesResponse } from "./motionplan";
import type { ComputePlanFramesRequest } from "./motionplan";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * World-space frame transforms from motion-plan JSON via RDK FK.
 *
 * @generated from protobuf service motionplan.v1.MotionPlanService
 */
export interface IMotionPlanServiceClient {
    /**
     * PlanRequest JSON, optionally followed by plan/trajectory.
     *
     * @generated from protobuf rpc: ComputePlanFrames(motionplan.v1.ComputePlanFramesRequest) returns (motionplan.v1.ComputePlanFramesResponse);
     */
    computePlanFrames(input: ComputePlanFramesRequest, options?: RpcOptions): UnaryCall<ComputePlanFramesRequest, ComputePlanFramesResponse>;
}
/**
 * World-space frame transforms from motion-plan JSON via RDK FK.
 *
 * @generated from protobuf service motionplan.v1.MotionPlanService
 */
export class MotionPlanServiceClient implements IMotionPlanServiceClient, ServiceInfo {
    typeName = MotionPlanService.typeName;
    methods = MotionPlanService.methods;
    options = MotionPlanService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * PlanRequest JSON, optionally followed by plan/trajectory.
     *
     * @generated from protobuf rpc: ComputePlanFrames(motionplan.v1.ComputePlanFramesRequest) returns (motionplan.v1.ComputePlanFramesResponse);
     */
    computePlanFrames(input: ComputePlanFramesRequest, options?: RpcOptions): UnaryCall<ComputePlanFramesRequest, ComputePlanFramesResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ComputePlanFramesRequest, ComputePlanFramesResponse>("unary", this._transport, method, opt, input);
    }
}
